import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Grid, Paper, Typography, Alert } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSettingsContext } from '../../components/settings';
import FormProvider, { RHFAutocomplete } from '../../components/hook-form';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { onPortalAddLabs,onPortalUpdateLabs } from '../../APIs/labs';
import { getPortalDataSources } from '../../APIs/data-source';
import { GridPaper, GridPaperSelect, GridPaperSwitch } from '../../components/custom-grid-input';

const classes = {
    root: {
        flexGrow: 1
    },
    paper: {
        padding: 5,
        textAlign: "center",
        color: "inherit"
    }
};

/* eslint-disable react/prop-types */
const LabView = ({ onChangeUser, item, onHandleClose, acids = [], readOnly = true }) => {
    const { themeStretch } = useSettingsContext();
    const axiosPrivate = useAxiosPrivate();

    const [types, setTypes] = useState([]);
    
    const [onlyVisible] = useState(true);
    const [showZero] = useState(true);

    const AddLabSchema = Yup.object().shape({
        id: Yup.number(),
        name: Yup.string().max(50).required('Lab Name is required'),        
        isActive: Yup.boolean()                
    });

    const defaultValues = {
        id: item?.id ?? 0,
        name: item?.name ?? '',        
        isActive: item?.isActive ?? true        
    };

    const methods = useForm({
        resolver: yupResolver(AddLabSchema),
        defaultValues
    });

    const {
        setValue,
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const handleSave = (request) => {
        const newRequest = { ...request }

        if (request.id > 0) {
            updateLab(newRequest);
        }
        else {
            addLab(newRequest);
        }
    }

    const addLab = (request) => {
        onPortalAddLabs(axiosPrivate, request, (response) => {
            if (response.status === 201) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    const updateLab = (request) => {
        onPortalUpdateLabs(axiosPrivate, request, (response) => {
            if (response.status === 200) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }
    
    return (
        <>
            <Helmet>
                <title>View Labs | flok</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'} spacing={{ xs: 0.5, sm: 1.5 }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(handleSave)}>
                    <div style={classes.root}>
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="h4" component="h4" paragraph>
                                    {readOnly ? 'View Lab' : `${item ? 'Update' : 'Add'} Lab`}
                                </Typography>
                                {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
                            </Grid>
                            <GridPaper name="name" label='Name' xs={12} readOnly={readOnly} />                            
                            <GridPaperSwitch name="isActive" label='Is Active' xs={3} readOnly={readOnly} />                                                        
                            <Grid container item xs={12} spacing={1}>
                                <Grid item xs={2}>
                                    <Paper style={classes.paper}>
                                        {!readOnly &&
                                            <LoadingButton
                                                type="submit"
                                                variant="contained"
                                                loading={isSubmitSuccessful || isSubmitting}
                                            >
                                                {item ? "Update" : "Add"}
                                            </LoadingButton>
                                        }
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </FormProvider>
            </Container>
        </>
    )
}

export default LabView;